import { ModulesMap } from '@/config/data/modulesMaps'
import WorksServicePaymentRateNormsApi from '@/services/apiServiceModules/worksServicePaymentRateNormsApi'
import DataTransferModule from '@/services/dataTransferModule'

const worksServicePaymentRateNormsApi = new WorksServicePaymentRateNormsApi()

export default class WorksServicePaymentRateNormsDt extends DataTransferModule {
	constructor() {
		super(ModulesMap.WORKS_SERVICE_PAYMENT_RATE_NORMS, worksServicePaymentRateNormsApi, {
			useCache: true,
		})
	}
}
